import { createContext } from 'react';

/**
 * Context to keep track of inline edition.
 */
export const InlineEditingContext = createContext(false);
